import { gql } from "apollo-boost"

export const SUBMISSION_SETTINGS_QUERY = gql`
  query submissionSettings($submissionId: ID!) {
    SubmissionSettings(
      submissionId: $submissionId
    ) {
      id
      lockedAssistanceDates {
        month
        year
        lockedActivities
        allowedActivities
        lockAllActivities
      }
    }
  }
`
